{
  "Accessibility Menu": "Menyu ya Ufikiaji",
  "Reset settings": "Weka upya mipangilio",
  "Close": "Funga",
  "Content Adjustments": "Marekebisho ya Maudhui",
  "Adjust Font Size": "Rekebisha Ukubwa wa Fonti",
  "Highlight Title": "Angazia Kichwa",
  "Highlight Links": "Angazia Viungo",
  "Readable Font": "Fonti Inayosomika",
  "Color Adjustments": "Marekebisho ya Rangi",
  "Dark Contrast": "Utofautishaji Gizani",
  "Light Contrast": "Utofautishaji Mwanga",
  "High Contrast": "Utofautishaji wa Juu",
  "High Saturation": "Mjazo wa Juu wa Rangi",
  "Low Saturation": "Mjazo wa Chini wa Rangi",
  "Monochrome": "Rangi Moja",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Visual & Navigation Aids": "Msaada wa Kuona na Kusogea",
  "Additional Tools": "Zana za Ziada",
  "Reading Guide": "Mwongozo wa Kusoma",
  "Stop Animations": "Sitisha Uhuishaji",
  "Big Cursor": "Kishale Kikubwa",
  "Screen Reader": "Kisoma Skrini",
  "Hide Images": "Ficha Picha",
  "Image Tooltips": "Maelezo ya Picha",
  "Page Structure": "Muundo wa Ukurasa",
  "Super Focus": "Umakini wa Juu",
  "Magnifier": "Kioo cha Kukuza",
  "Increase Font Size": "Ongeza Ukubwa wa Fonti",
  "Decrease Font Size": "Punguza Ukubwa wa Fonti",
  "Letter Spacing": "Nafasi ya Herufi",
  "Line Height": "Urefu wa Mstari",
  "Font Weight": "Uzito wa Fonti",
  "Dyslexia Font": "Fonti ya Disklesia",
  "Language": "Lugha",
  "Open Accessibility Menu": "Fungua Menyu ya Ufikiaji",
  "Accessibility Profiles": "Wasifu wa Ufikiaji",
  "Seizure Safe Profile": "Wasifu Salama kwa Mshtuko",
  "Stops animations and reduces color saturation.": "Inasimamisha uhuishaji na kupunguza msongo wa rangi.",
  "Blind Profile": "Wasifu kwa Vipofu",
  "Activates the screen reader for auditory navigation.": "Inawasha kisoma skrini kwa urambazaji wa kusikia.",
  "Visually Impaired Profile": "Wasifu kwa Wenye Uoni Hafifu",
  "Enhances contrast and readability for low vision.": "Inaboresha utofauti na usomekaji kwa uoni hafifu.",
  "ADHD Friendly Profile": "Wasifu Rafiki kwa ADHD",
  "Reduces distractions for better focus.": "Inapunguza vikengeusha kwa umakini bora.",
  "Cognitive & Learning Profile": "Wasifu wa Utambuzi na Kujifunza",
  "Helpful tools for reading and comprehension.": "Zana za kusaidia usomaji na ufahamu.",
  "Motor Impaired Profile": "Wasifu kwa Walemavu wa Mwili",
  "Optimizes the site for keyboard-only navigation.": "Inaboresha tovuti kwa urambazaji wa kibodi pekee.",
  "Headings": "Vichwa vya Habari",
  "Landmarks": "Alama",
  "Links": "Viungo",
  "Focus element": "Lenga kipengele",
  "Visit link": "Tembelea kiungo"
}